<template>
    <div class="col-md-12">
        <div class="row">
            <div class="row mt-4">
                <div class="col-md-12">
                    <p>Dirección laboral</p>
                    <FormDireccion v-model="direccionLaboral" />
                </div>
            </div>
        </div>

        <hr/>
        <div class="row mt-4">
            <div class="col-md-4">
                <div class="col-md-12">
                    <h5 class="text-primary">Información de trabajo</h5>
                </div>
             </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-4">
                <div class="form-group">
                    <label class="control-label">Lugar de trabajo</label>
                    <select class="form-control" required="required" v-model="store.lugarTrabajoId" @change="controlLugarTrabajo()">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option value="1">Secretaría de Salud</option>
                        <option value="2">Otro</option>
                    </select>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label class="control-label">Organización</label>
                    <select class="form-control" required="required" :disabled="disabledOrganizaciones" v-model="store.organizacionId" @change="controlOrganizacion()">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option v-for="organizacion in store.organizaciones" :key="organizacion.id" :value="organizacion.id">{{ organizacion.nombre }}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label class="control-label">Unidad</label>
                    <select class="form-control" required="required" :disabled="disabledUnidades" v-model="store.unidadId">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option v-for="unidad in unidadesFiltradas" :key="unidad.id" :value="unidad.id">{{ unidad.nombre }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row mt-3" v-if="store.lugarTrabajoId == '1'">
            <div class="col-md-12">
                <p><strong>Dirección de la Unidad</strong></p>
                <FormDireccion v-model="direccionUnidad" />
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="control-label">Referencia particular</label>
                    <textarea v-model="store.referencia" :disabled="disabledReferencia" class="form-control" rows="3" style="resize: none;" placeholder="Describa la ubicación particular del puesto de trabajo" required="required" />
                </div>
            </div>
        </div>

        <hr class="mt-3" />
        <div class="mt-3 col-md-12">
            <p><b>* Campos obligatorios</b></p>
        </div>

        <div class="mt-3 col-md-12">
            <button class="btn btn-primary float-end" @click="guardaInformacionLaboralYAvanza">
                {{ accionGuardarLabel }}
            </button>
        </div>
    </div>
</template>

<script>
import { useSeguroStore } from '@/stores/seguroStore';
import FormDireccion from '@/components/FormDireccion.vue';
import api from '@/axios';
import { fetchAllItems } from '@/utils/listResponse';
import getField from '@/utils/getField';

const TIPO_DOMICILIO_LABORAL = 2;

const getEmptyDomicilioLaboral = () => ({
    tipoId: TIPO_DOMICILIO_LABORAL,
    codigoPostal: '',
    codigoPostalId: null,
    estado: '',
    estadoId: null,
    municipio: '',
    municipioId: null,
    colonia: '',
    calle: '',
    ciudad: '',
    paisId: 1,
    numeroExt: '',
    numeroInt: '',
    disabledCP: 1,
});

export default {
    components: { FormDireccion },
    setup() {
        const store = useSeguroStore();
        return { store };
    },
    data() {
        return {
            errors: [],
            formSubmitted: false,
            tiposPoliza: [{ id: 1, nombre: 'Individual' }, { id: 2, nombre: 'Colectiva' }],
            disabledOrganizaciones: true,
            disabledUnidades: true,
            disabledReferencia: 0,
        }
    },
    computed: {
        accionGuardarLabel() {
            return this.store.contratanteId ? 'Actualizar y avanzar' : 'Guardar y avanzar';
        },
        unidadesFiltradas() {
            if (!this.store.organizacionId) return [];
            return (this.store.unidades || []).filter(u => u.organizacionId == this.store.organizacionId);
        },
        direccionUnidad: {
            get() { return this.store.direccionUnidad; },
            set(val) { this.store.direccionUnidad = val; },
        },
        direccionLaboral: {
            get() {
                if (!Array.isArray(this.store.domicilios)) return getEmptyDomicilioLaboral();
                const laboral = this.store.domicilios.find(d => d.tipoId === TIPO_DOMICILIO_LABORAL);
                return laboral || getEmptyDomicilioLaboral();
            },
            set(val) {
                if (!Array.isArray(this.store.domicilios)) {
                    this.store.domicilios = [];
                }
                const laboralIndex = this.store.domicilios.findIndex(d => d.tipoId === TIPO_DOMICILIO_LABORAL);
                const next = { ...getEmptyDomicilioLaboral(), ...val, tipoId: TIPO_DOMICILIO_LABORAL };
                if (laboralIndex >= 0) {
                    this.store.domicilios[laboralIndex] = next;
                } else {
                    this.store.domicilios.push(next);
                }
            },
        },
    },
    mounted() {
        this.fetchOrganizaciones();
        this.fetchUnidades();
    },
    methods: {
        buildWizardDtoEtapa2() {
            const dto = this.store.buildWizardDto(2);
            // Asegura que el domicilio laboral esté incluido en el array
            const laboral = this.direccionLaboral || getEmptyDomicilioLaboral();
            const laboralDto = {
                tipoId: TIPO_DOMICILIO_LABORAL,
                calle: laboral.calle || null,
                numeroExt: laboral.numeroExt || null,
                numeroInt: laboral.numeroInt || null,
                codigoPostal: laboral.codigoPostal || null,
                codigoPostalId: laboral.codigoPostalId || null,
                colonia: laboral.colonia || null,
                ciudad: laboral.ciudad || null,
                municipioId: laboral.municipioId || null,
                estadoId: laboral.estadoId || null,
                paisId: laboral.paisId || 1,
            };
            const sinLaboral = (dto.domicilios || []).filter(d => d.tipoId !== TIPO_DOMICILIO_LABORAL);
            dto.domicilios = [...sinLaboral, laboralDto];
            return dto;
        },
        async guardaInformacionLaboral() {
            if (!this.store.polizaId) {
                this.errors.push({ mensaje: 'No se encontró polizaId para actualizar información laboral.' });
                return false;
            }
            try {
                const payload = this.buildWizardDtoEtapa2();
                const response = await api.put(`wizard/poliza/${this.store.polizaId}`, payload);
                if (response.status >= 200 && response.status < 300) {
                    const data = response.data || {};
                    if (data.informacionLaboralId) {
                        this.store.informacionLaboralId = data.informacionLaboralId;
                    }
                    this.store.polizaVersionId = getField(data, 'polizaVersionId') ?? this.store.polizaVersionId;
                    this.store.etapaWizard = 2;
                    return true;
                }
                return false;
            } catch (err) {
                this.errors.push({ mensaje: 'No se pudo actualizar la información laboral.' });
                return false;
            }
        },
        async guardaInformacionLaboralYAvanza() {
            const ok = await this.guardaInformacionLaboral();
            if (ok) {
                this.$emit('nextTab');
            }
        },
        controlLugarTrabajo() {
            const esSecretaria = this.store.lugarTrabajoId == '1';
            this.disabledOrganizaciones = !esSecretaria;
            this.disabledUnidades = !esSecretaria;
            if (!esSecretaria) {
                this.store.organizacionId = '';
                this.store.unidadId = '';
            }
        },
        controlOrganizacion() {
            this.store.unidadId = '';
        },
        async fetchOrganizaciones() {
            if (Array.isArray(this.store.organizaciones) && this.store.organizaciones.length > 0) {
                return;
            }
            try {
                this.store.organizaciones = (await fetchAllItems('organizaciones')).items.map(item => ({
                        id: item.id,
                        nombre: item.nombre,
                    }));
            } catch (err) {
                this.errors.push({ mensaje: 'No se pudieron cargar las organizaciones.' });
            }
        },
        async fetchUnidades() {
            if (Array.isArray(this.store.unidades) && this.store.unidades.length > 0) {
                return;
            }
            try {
                this.store.unidades = (await fetchAllItems('unidades')).items.map(item => ({
                        id: item.id,
                        nombre: item.nombre,
                        organizacionId: item.organizacionId,
                    }));
            } catch (err) {
                this.errors.push({ mensaje: 'No se pudieron cargar las unidades.' });
            }
        }
    }
}
</script>
